/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{32E2E0B6-69BD-4E48-9363-2B783724C1A5}",
  "sitecoreApiHost": "https://www.infinity-group.pl",
  "jssAppName": "sig",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/sig",
  "graphQLEndpoint": "https://www.infinity-group.pl/api/sig?sc_apikey={32E2E0B6-69BD-4E48-9363-2B783724C1A5}"
};